import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=a25fcd08"
import script from "./LoginCard.vue?vue&type=script&lang=ts"
export * from "./LoginCard.vue?vue&type=script&lang=ts"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=a25fcd08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports